<template>
  <section class="l-content-area">
    <div class="l-content l-content--login">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner mb-6">
          <section class="c-title__bloc c-title__bloc--login">
            <h1>{{ text.title }}</h1>
          </section>
          <section class="p-bloc holiday__bloc mt-16">
            <div class="confirm-message">
              <p>{{ text.heading }}</p>
            </div>
          </section>
        </div>
        <div>
          <button-registration
            :next-text="text.nextButton"
            :handle-next-button="nextStep"
            :is-prev-button="false"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonRegistration from '../common/ButtonRegistration'

export default {
  name: 'ContactConfirm',
  components: { ButtonRegistration },
  data() {
    return {
      text: {
        title: 'お問合せ送信完了',
        heading:
          'お問合せありがとうございます。内容を確認し、担当者より折り返しご連絡いたします。返信にはお時間をいただく場合がございますので、ご了承ください。',
        nextButton: 'ログイン画面へ',
      },
    }
  },
  methods: {
    nextStep() {
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style scoped lang="scss">
.confirm-message {
  background-color: #f5f5f5;
  border-radius: 3px;
  color: #0a005a;
  font-size: 14px;
  padding: 30px 20px;
  margin: 0 auto;
  max-width: 440px;
  height: 140px;
  text-align: center;
  display: flex;
  align-items: center;
}
</style>
